import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";

gsap.registerPlugin(ScrollTrigger);

document.addEventListener("DOMContentLoaded", () => {
  const aboutHeading = document.querySelector(".about-title");
  const aboutSubtext = document.querySelector(".about-subtext");
  const portfolio_heading = document.querySelector(".portfolio-heading");
  const portfolio_items = document.querySelector(".portfolio-items");

  if (!aboutHeading) return;

  gsap.fromTo(
    aboutHeading,
    {
      opacity: 0,
      y: 50,
      filter: "blur(5px)",
    },
    {
      opacity: 1,
      y: 0,
      filter: "blur(0px)",
      duration: 1.6,
      ease: "power3.out",
      scrollTrigger: {
        trigger: aboutHeading,
        start: "top 80%", // starts when the heading is near the viewport
        toggleActions: "play none none reverse", // animates back when scrolling up
      },
    }
  );

  gsap.fromTo(
    aboutSubtext,
    {
      opacity: 0,
      filter: "blur(10px)",
    },
    {
      opacity: 1,
      filter: "blur(0px)",
      duration: 1.9,
      ease: "power3.out",
      scrollTrigger: {
        trigger: aboutHeading,
        start: "top 80%", // starts when the heading is near the viewport
        toggleActions: "play none none reverse", // animates back when scrolling up
      },
    }
  );

  gsap.fromTo(
    portfolio_heading,
    {
      opacity: 0,
      filter: "blur(10px)",
    },
    {
      opacity: 1,
      filter: "blur(0px)",
      duration: 1.9,
      ease: "power3.out",
      scrollTrigger: {
        trigger: portfolio_heading,
        start: "top 80%", // starts when the heading is near the viewport
        toggleActions: "play none none reverse", // animates back when scrolling up
      },
    }
  );

  gsap.fromTo(
    portfolio_items,
    {
      opacity: 0,
      filter: "blur(10px)",
    },
    {
      opacity: 1,
      filter: "blur(0px)",
      duration: 1.9,
      ease: "power3.out",
      scrollTrigger: {
        trigger: portfolio_items,
        start: "top 80%", // starts when the heading is near the viewport
        toggleActions: "play none none reverse", // animates back when scrolling up
      },
    }
  );
});
